var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('e-charts',{ref:"wheelChart",staticClass:"z-10 w-full h-full absolute inset-0",attrs:{"autoresize":true,"options":_vm.options},on:{"click":_vm.onChartClick}})}
var staticRenderFns = []

export { render, staticRenderFns }